import debounce from "@wwdev/functions/debounce";

class Configurator {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-configurator="scope"]',
			options: '[data-configurator="product-selector"]',
			summary: '[data-configurator="summary"]',
			radio: '[data-configurator="radio"]',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.$scope.on('change', this.config.radio, debounce(this.onRadioChange.bind(this), 300));
	}

	onRadioChange(event) {
		let data = {options: {}};

		this.$scope.find(this.config.radio + ':is(:checked)').each((index, input) => {
			let $input = $(input);

			let options = $input.data('option');
			if(!options) {
				return;
			}

			for(let group in options) {
				data['options'][group] = options[group];
			}
		})

		data['action'] = 'save_options';
		this._doRequest(data);
	}

	_doRequest(data, method = 'POST') {
		this._beforeRequest();

		return $.ajax({
			method: method,
			data: data,
			success: this._onSuccess.bind(this),
			error: this._onError.bind(this)
		}).always(() => {
			this._afterRequest();
		});
	}

	_beforeRequest() {
		window.showLoader();
	}

	_afterRequest() {
		window.hideLoader();
	}

	_onSuccess(response) {
		this.$scope.find(this.config.summary).html(response.summary);
	}

	_onError(error) { }

	_deparam(query) {
		function addValue(obj, keys, value) {
			let entry = keys.shift();
			let key = entry.replace(/\[/, '').replace(/\]/, '');
			if (keys.length > 0) {
				if (typeof obj[key] == 'undefined') {
					obj[key] = {};
				}
				addValue(obj[key], keys, value)
			} else {
				obj[key] = value;
			}
		}

		if (query == '') return {};
		query = query.replace(/^\?/, '');
		var hash = {};
		var vars = query.split("&");
		for (var i = 0; i < vars.length; i++) {
			var pair = vars[i].split("=");
			var k = decodeURIComponent(pair[0]);
			var v = decodeURIComponent(pair[1]);      // If it is the first entry with this name
			let matches = k.match(/\[(.*?)\]/g);
			let matches2 = k.match(/([A-z]+)\[\]/);

			if(matches2 && matches2.length > 0) {
				if(typeof hash[matches2[1]] == 'undefined') {
					hash[matches2[1]] = [];
				}
				hash[matches2[1]].push(v);
			} else if(matches && matches.length > 0) {
				let realKey = k.match(/^[a-zA-Z0-9]+/);
				if (typeof hash[realKey[0]] == 'undefined') {
					hash[realKey[0]] = {};
				}
				addValue(hash[realKey[0]], matches, v)
			} else {
				hash[k] = v;
			}

		}
		return hash;
	}
}

export default new Configurator;